var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard has-background-black has-text-white p-2" },
    [
      _c("div", { staticClass: "fixed-grid has-4-cols" }, [
        _c("div", { staticClass: "grid" }, [
          _c(
            "div",
            { staticClass: "cell is-col-span-2 is-flex" },
            [
              _c("DashboardStatues", {
                attrs: {
                  "is-uninvoiced-jobs-and-chart-disabled":
                    _vm.isUninvoicedJobsAndChartDisabled,
                  "data-obj": _vm.defaultDataObj,
                },
              }),
            ],
            1
          ),
          _vm.showDashboardInsurerMessages
            ? _c(
                "div",
                {
                  staticClass:
                    "cell is-flex is-flex-direction-column is-flex-grow-1",
                },
                [
                  _c("DashboardInsurerMessages", {
                    staticClass: "is-flex-grow-1",
                    attrs: {
                      "is-uninvoiced-jobs-and-chart-disabled":
                        _vm.isUninvoicedJobsAndChartDisabled,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass:
                "cell is-flex is-flex-direction-column is-flex-grow-1",
              class: { "is-col-span-2": !_vm.showDashboardInsurerMessages },
            },
            [
              _c("DashboardIncomingMessages", {
                staticClass: "is-flex-grow-1",
                attrs: {
                  "is-uninvoiced-jobs-and-chart-disabled":
                    _vm.isUninvoicedJobsAndChartDisabled,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "fixed-grid has-12-cols" }, [
        _c("div", { staticClass: "grid" }, [
          !_vm.isUninvoicedJobsAndChartDisabled
            ? _c("div", { staticClass: "cell is-col-span-9" }, [
                _c("div", { staticClass: "grid has-2-cols" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "cell is-flex is-flex-direction-column is-flex-grow-1",
                    },
                    [
                      _c("DashboardUnInvoicedJobs", {
                        staticClass: "is-flex-grow-1",
                        attrs: { "default-data-obj": _vm.defaultDataObj },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "cell" },
                    [_c("DashboardTotalJobs")],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "cell",
              class: _vm.isUninvoicedJobsAndChartDisabled
                ? "is-col-span-12"
                : "is-col-span-3",
            },
            [_c("DashboardReleaseNotes")],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }